import moment from "moment";
import baseAPI from "../api/baseApi";
import { authHeader, authHeaderWithImage } from "../helpers/authHeader";
import { toast } from "react-toastify";

const getBranches = async (data) => {
  try {
    const res = await baseAPI.get(
      `/get-branches?page=${data.page}&search=${data.search}`,
      {
        headers: authHeader(),
      }
    );
    return res.data;
  } catch (error) {
    console.log(error);
  }
};

const addBranch = async (data) => {
  try {
    const formdata = new FormData();

    formdata.append("name", data.name);
    formdata.append("mobile_number", data.mobile_number);
    formdata.append("email", data.email);
    // formdata.append("category_id", data.category_id);

    if (Array.isArray(data.category_id)) {
      data.category_id.forEach((cat, index) => {
        formdata.append(`category_id[${index}]`, cat.value);
      });
    } else {
      formdata.append("category_id", data.category_id);
    }

    formdata.append("address", data.address);
    // formdata.append("city_id", data.city_id);
    formdata.append("district_id", data.district_id);
    formdata.append("country_id", data.country_id);
    formdata.append("latitude", data.latitude);
    formdata.append("longitude", data.longitude);
    formdata.append("facebook", data.facebook);
    formdata.append("instagram", data.instagram);
    formdata.append("twitter", data.twitter);
    formdata.append("start_working_hour", data.start_working_hour);
    formdata.append("end_working_hour", data.end_working_hour);
    formdata.append("short_address", data.short_address);

    const res = await baseAPI.post(`/add-branch`, formdata, {
      headers: authHeader(),
    });
    return res.data;
  } catch (error) {
    console.log(error);
    toast.error(error?.response?.data?.message);
  }
};

const getBranchById = async (id) => {
  try {
    const res = await baseAPI.get(`/get-branch-details?branch_id=${id}`, {
      headers: authHeader(),
    });
    return res.data;
  } catch (error) {
    console.log(error);
  }
};

const editBranch = async (data) => {
  try {
    const formdata = new FormData();

    formdata.append("name", data.name);
    formdata.append("mobile_number", data.mobile_number);
    formdata.append("email", data.email);
    // formdata.append("category_id", data.category_id);
    if (Array.isArray(data.category_id)) {
      data.category_id.forEach((cat, index) => {
        formdata.append(`category_id[${index}]`, cat.value);
      });
    } else {
      formdata.append("category_id", data.category_id);
    }
    formdata.append("address", data.address);
    // formdata.append("city_id", data.city_id);
    formdata.append("district_id", data.district_id);
    formdata.append("country_id", data.country_id);
    formdata.append("latitude", data.latitude);
    formdata.append("longitude", data.longitude);
    formdata.append("facebook", data.facebook);
    formdata.append("instagram", data.instagram);
    formdata.append("twitter", data.twitter);
    formdata.append("start_working_hour", data.start_working_hour);
    formdata.append("end_working_hour", data.end_working_hour);
    formdata.append("branch_id", data.branch_id);
    formdata.append("short_address", data.short_address);

    const res = await baseAPI.post(`/edit-branch`, formdata, {
      headers: authHeader(),
    });
    return res.data;
  } catch (error) {
    console.log(error);
    toast.error(error?.response?.data?.message);
  }
};

const deleteBranch = async (data) => {
  try {
    const formdata = new FormData();
    formdata.append("branch_id", data.branch_id);

    const res = await baseAPI.post(`/delete-branch`, formdata, {
      headers: authHeader(),
    });
    return res.data;
  } catch (error) {
    console.log(error);
  }
};
const BranchService = {
  getBranches,
  addBranch,
  getBranchById,
  editBranch,
  deleteBranch,
};

export default BranchService;
